var MpPagePublicTenders;

(function() {
    if (!document.querySelector('#vue-body-publictenders') || GLOBAL_SECTION === 'publictender_detail') {
        return;
    }

    var sectionList = {
        publictender: MpSearchPublicTender,
        publictender_tags: MpTagPublicTender,
    };

    if (GLOBAL_SECTION === 'publictender') {
        Vue.component('flat-pickr', VueFlatpickr);
    }

    MpPagePublicTenders = new Vue({
        el: '#vue-body-publictenders',
        mixins: [MpPaginator, sectionList[GLOBAL_SECTION]],

        data: {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            itemList: [],
            totalResultsTPL: '',
            totalItems: 0,

            allChecked: false,

            overlay: null,
            isInitialized: false,
        },

        computed: {

            totalResults: function () {
                return this.totalResultsTPL.replace('%s', this.totalItems);
            },
        },

        methods: {

            getItemClasses: function(item) {
                return {
                    'card-publictender__daysbox--toend': item.daystoclose >= 1 && item.daystoclose < item.daystoadvise,
                    'card-publictender__daysbox--closed': item.daystoclose <= 0,
                };
            },

            getItemDaysBoxContent: function(item) {
                // <span :class="highlighted(item)">{{item.daystoclose}}</span>
                if (item.daystoclose > 0) {
                    return (item.daystoclose > 1) ? TXT_DAYS_LEFT.replace('%s', item.daystoclose) : TXT_DAY_LEFT.replace('%s', item.daystoclose);
                } else {
                    return TXT_CLOSED;
                }
            },

            highlighted: function(item) {
                return (item.daystoclose > 1 && item.daystoadvise < item.daystoclose) ? 'highlight' : '';
            },

            getDateFromString: function(dateStr) {
                var dateParts = dateStr.split('-');
                return new Date(parseInt(dateParts[0]), parseInt(dateParts[1])-1, parseInt(dateParts[2]));
            },

            addDomItem: function(item) {
                this.itemList.push({
                    id: item.dataset.id,
                    daystoadvise: parseInt(item.dataset.daystoadvise),
                    daystoclose: parseInt(item.dataset.daystoclose),
                    date: item.dataset.date,
                    dateEnd: item.dataset.date_end,
                    company: item.dataset.company,
                    amount: (item.dataset.amount != 0) ? item.dataset.amount : null,
                    category_id: item.dataset.category_id,
                    category_name: item.dataset.category_name,
                    origin: item.dataset.origin,
                    province: item.dataset.province,
                    uri: item.dataset.uri,
                    title: item.dataset.title,
                });
            },

            onItemsLoaded: function(response) {
                if (response.data.result == this.RESPONSE_OK) {
                    this.itemList = response.data.registers;
                    this.updatePaginator(response);
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                window.addEventListener('hashchange', this.onHashChange);
                this.onHashChange();

                this.initPaginator();
                this.isInitialized = true;
            },
        },
        filters: {},

        mounted: function() {
            this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);

            this.setInitialPage(parseInt(this.$refs.ssrPaginator.dataset.page));
            this.$refs.ssrPaginator.querySelectorAll('.js-page-item').forEach(this.addDomPage);

            this.totalResultsTPL = this.$refs.ssrTotalItems.getAttribute('data-tpl');
            this.totalItems = this.$refs.ssrTotalItems.getAttribute('data-total');

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
            window.removeEventListener('hashchange', this.onHashChange);
        }
    });

})();
